import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const auditDisclosureSnapshotService = createApi({
    reducerPath: 'auditDisclosureSnapshotService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['AuditDisclosureSnapshot'],
    endpoints: (builder) => ({
        getAllAuditDisclosureSnapshot: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.auditDisclosureSnapshotController.search}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        saveAuditDisclosureSnapshot: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.auditDisclosureSnapshotController.save}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateAuditDisclosureSnapshot: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.auditDisclosureSnapshotController.update}/${body.payload.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteAuditDisclosureSnapshot: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.auditDisclosureSnapshotController.delete}/${body.id}${body.type ? `?type=${body.type}` : ""}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            },
        }),
        getAuditDisclosureSnapshotById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.auditDisclosureSnapshotController.getById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        findAllAuditDisclosureSnapshot: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.auditDisclosureSnapshotController.findAll}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        bulkUploadAuditDisclosureSnapshot: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.auditDisclosureSnapshotController.uploadBulk}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
    })
});

export const {
    useGetAllAuditDisclosureSnapshotMutation,
    useSaveAuditDisclosureSnapshotMutation,
    useUpdateAuditDisclosureSnapshotMutation,
    useDeleteAuditDisclosureSnapshotMutation,
    useGetAuditDisclosureSnapshotByIdMutation,
    useFindAllAuditDisclosureSnapshotMutation,
    useBulkUploadAuditDisclosureSnapshotMutation,
} = auditDisclosureSnapshotService;
